import React from "react"
import Treatment from "../components/tratment/treatment"

import Layout from "../components/layout"
import SEO from "../components/seo"
import image from "../images/laser1.jpg"

const description = (
  <div>
    <p>
      <strong>Laser hair removal</strong> is the process of removing unwanted
      hair by means of exposure to pulses of laser light that destroy the hair
      follicle. There are a number of treatments that will get rid of unwanted
      body hair. However, most of these hair removal treatments do not produce
      permanent results, are painful to the patient and have to be repeated
      several times.
    </p>
    <p>
      We offer the latest laser hair removal treatments that permanently reduce
      body & facial hair. Prevent the re-growth of hair, freeing you from the
      inconvenience of painful waxing or shaving and the constant worry of
      unsightly hair. Our salon is using cutting-edge medical grade laser to
      achieve the best results.
    </p>
    <p>
      The effectiveness of our treatments is based on a simple schedule of
      repeated laser treatments, spaced over the period of a few weeks. The time
      gaps ensure that the hair follicles can be targeted in their growth stage,
      with their removal at this early stage causing a gradual reduction in hair
      growth and a long lasting smooth hairless appearance.
    </p>
    <p>
      Our Laser is suitable for most of skin types, with 3-8 recommended
      sessions.
    </p>
    <p>
      This advanced hair removal laser machine offers a effective way to stop
      hair growth in unwanted areas. Their superior technology means you will
      get better results with less treatments, achieving smoother hair-free skin
      faster than salons that use older machines.
    </p>
    <p>
      Contact us with any further questions you may have about our laser hair
      removal treatments. Our knowledgeable staff will book in your free
      consultation to discuss your target areas and schedule.
    </p>
  </div>
)

const Laser = () => (
  <Layout>
    <SEO title="Laser hair removal" />
    <Treatment
      image={image}
      title="Laser hair removal"
      htmlText={description}
    />
  </Layout>
)

export default Laser
